import {Checkbox, RadioGroup, Radio, FormControl, FormLabel, FormControlLabel} from "@mui/material";
import React, {useEffect, useState} from "react";
import {makeStyles} from "@mui/styles";
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Button from "@mui/material/Button";
import globalVars from "../utils/globalVars";

const useStylesNormal = makeStyles({
        mycheckbox: {
            backgroundColor: 'transparent'
        }
    }
);

const useStylesFeedback = makeStyles({
        mycheckbox: {
            backgroundColor: ok => ok ? globalVars.feedbackMode.backgroundColor.ok : globalVars.feedbackMode.backgroundColor.notOk,
            // borderWidth: "1px",
            // borderStyle: "solid",
            // borderColor: ok => ok ? '#3ff' : '#f3f',
        }
    }
);

export default function CheckboxSubcomponent(props) {

    const [expectedChecked, setExpectedChecked] = useState(props.expectedChecked);
    const [currentChecked, setCurrentChecked] = useState(false);
    const [ok, setOk] = useState(false)
    const mode = 'mode_feedback'

    // const classes = useStyles(ok);
    const classesModeNormal = useStylesNormal();
    const classesModeFeeback = useStylesFeedback(expectedChecked == currentChecked);
    const classes = {
        'mode_normal': classesModeNormal,
        'mode_feedback': classesModeFeeback,
    }

    function handleChange(e) {
        setCurrentChecked(e.target.value);
    }

    const mystyle = {padding: '0px', margin: '0px'};
    return (
        <FormControl
            // sx={{border: '1px solid red'}}
        >
            <RadioGroup
                className={classes[props.feedbackMode].mycheckbox}
                row
                onChange={handleChange}
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
            >
                <FormControlLabel title={props.answers.true}
                                  value={props.answers.true}
                                  sx={mystyle}
                                  key="true"
                                  control={
                                      <Radio
                                          key="radiotrue"
                                          checkedIcon={
                                              <Button sx={{textTransform: 'none'}} size="small" variant="contained" key="truechecked">
                                                  {props.answers.true}
                                              </Button>
                                          }
                                          icon={
                                              <Button sx={{textTransform: 'none'}} size="small" variant="outlined" key="trueunchecked">
                                                  {props.answers.true}
                                              </Button>
                                          }
                                      />
                                  }
                                  label=""
                />
                <FormControlLabel title={props.answers.false}
                                  value={props.answers.false}
                                  sx={mystyle}
                                  key="false"
                                  control={
                                      <Radio
                                          key="radiofalse"
                                          checkedIcon={
                                              <Button sx={{textTransform: 'none'}} size="small" variant="contained" key="falsechecked">
                                                  {props.answers.false}
                                              </Button>
                                          }
                                          icon={
                                              <Button sx={{textTransform: 'none'}} size="small" variant="outlined" key="falseunchecked">
                                                  {props.answers.false}
                                              </Button>
                                          }
                                      />
                                  }
                                  label=""
                />
                {/*<FormControlLabel title="x" value="x" control={<Radio checkedIcon={<CheckBoxIcon />} icon={<CheckBoxOutlineBlankIcon />}/>} label=""/>*/}
                {/*<FormControlLabel title="y" value="y" control={<Radio checkedIcon={<CheckBoxIcon />} icon={<CheckBoxOutlineBlankIcon />}/>} label=""/>*/}
                {/*<FormControlLabel title="z" value="z" control={<Radio checkedIcon={<CheckBoxIcon />} icon={<CheckBoxOutlineBlankIcon />}/>} label=""/>*/}
            </RadioGroup>
        </FormControl>
    )
}